module.exports = AwesomeQR;